import { render } from "./getIp.vue?vue&type=template&id=7118b298"
import script from "./getIp.vue?vue&type=script&lang=js"
export * from "./getIp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__